/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListNodeTemplatesMetricsResponse } from '../models';
// @ts-ignore
import type { ListSpotInterruptionPredictionPerformanceMetricsResponse } from '../models';
// @ts-ignore
import type { NodeLabelsFilter } from '../models';
// @ts-ignore
import type { SpotInterruptionPredictionPerformanceSummary } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * NodeTemplateAPIApi - axios parameter creator
 * @export
 */
export const NodeTemplateAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns avg spot interruption ratio for the entire period — as a single overall value and broken down per node template.
         * @summary Returns spot interruption prediction performance summary.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {Array<string>} [nodeTemplateNames] Node template names to filter the report. If empty, all node templates are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary: async (organizationId: string, clusterIds?: Array<string>, nodeTemplateNames?: Array<string>, startTime?: string, endTime?: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/node-templates/spot-interruption-prediction-performance-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterIds) {
                localVarQueryParameter['clusterIds'] = clusterIds;
            }

            if (nodeTemplateNames) {
                localVarQueryParameter['nodeTemplateNames'] = nodeTemplateNames;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step.
         * @summary Returns resource usage per node template.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListNodeTemplatesMetricsStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum} [filterOperator] Logical operator for combining label requirements. Defaults to AND if unset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListNodeTemplatesMetrics: async (organizationId: string, clusterIds?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListNodeTemplatesMetricsStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, filterOperator?: NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeTemplateAPIListNodeTemplatesMetrics', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/node-templates-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterIds) {
                localVarQueryParameter['clusterIds'] = clusterIds;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (filterOperator !== undefined) {
                localVarQueryParameter['filter.operator'] = filterOperator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step, with optional filtering by cluster IDs and node labels.
         * @summary Returns resource usage per node template with label filtering.
         * @param {string} organizationId Organization ID.
         * @param {NodeLabelsFilter} nodeLabelsFilter 
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListNodeTemplatesMetricsFiltered: async (organizationId: string, nodeLabelsFilter: NodeLabelsFilter, clusterIds?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeTemplateAPIListNodeTemplatesMetricsFiltered', 'organizationId', organizationId)
            // verify required parameter 'nodeLabelsFilter' is not null or undefined
            assertParamExists('nodeTemplateAPIListNodeTemplatesMetricsFiltered', 'nodeLabelsFilter', nodeLabelsFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/node-templates-metrics:filtered`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterIds) {
                localVarQueryParameter['clusterIds'] = clusterIds;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeLabelsFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns avg spot interruption ratio per node template per time bucket at the requested granularity.
         * @summary Returns spot interruption prediction performance metrics time-series.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {Array<string>} [nodeTemplateNames] Node template names to filter the report. If empty, all node templates are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics: async (organizationId: string, clusterIds?: Array<string>, nodeTemplateNames?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/node-templates/spot-interruption-prediction-performance-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterIds) {
                localVarQueryParameter['clusterIds'] = clusterIds;
            }

            if (nodeTemplateNames) {
                localVarQueryParameter['nodeTemplateNames'] = nodeTemplateNames;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeTemplateAPIApi - functional programming interface
 * @export
 */
export const NodeTemplateAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeTemplateAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns avg spot interruption ratio for the entire period — as a single overall value and broken down per node template.
         * @summary Returns spot interruption prediction performance summary.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {Array<string>} [nodeTemplateNames] Node template names to filter the report. If empty, all node templates are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(organizationId: string, clusterIds?: Array<string>, nodeTemplateNames?: Array<string>, startTime?: string, endTime?: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotInterruptionPredictionPerformanceSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(organizationId, clusterIds, nodeTemplateNames, startTime, endTime, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeTemplateAPIApi.nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step.
         * @summary Returns resource usage per node template.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListNodeTemplatesMetricsStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum} [filterOperator] Logical operator for combining label requirements. Defaults to AND if unset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTemplateAPIListNodeTemplatesMetrics(organizationId: string, clusterIds?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListNodeTemplatesMetricsStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, filterOperator?: NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodeTemplatesMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTemplateAPIListNodeTemplatesMetrics(organizationId, clusterIds, startTime, endTime, step, timeZone, pageLimit, pageCursor, filterOperator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeTemplateAPIApi.nodeTemplateAPIListNodeTemplatesMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step, with optional filtering by cluster IDs and node labels.
         * @summary Returns resource usage per node template with label filtering.
         * @param {string} organizationId Organization ID.
         * @param {NodeLabelsFilter} nodeLabelsFilter 
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTemplateAPIListNodeTemplatesMetricsFiltered(organizationId: string, nodeLabelsFilter: NodeLabelsFilter, clusterIds?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodeTemplatesMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTemplateAPIListNodeTemplatesMetricsFiltered(organizationId, nodeLabelsFilter, clusterIds, startTime, endTime, step, timeZone, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeTemplateAPIApi.nodeTemplateAPIListNodeTemplatesMetricsFiltered']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns avg spot interruption ratio per node template per time bucket at the requested granularity.
         * @summary Returns spot interruption prediction performance metrics time-series.
         * @param {string} organizationId Organization ID.
         * @param {Array<string>} [clusterIds] Cluster IDs to filter the report. If empty, all clusters in the organization are included.
         * @param {Array<string>} [nodeTemplateNames] Node template names to filter the report. If empty, all node templates are included.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum} [step] Granularity of data points.
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(organizationId: string, clusterIds?: Array<string>, nodeTemplateNames?: Array<string>, startTime?: string, endTime?: string, step?: NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum, timeZone?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSpotInterruptionPredictionPerformanceMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(organizationId, clusterIds, nodeTemplateNames, startTime, endTime, step, timeZone, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeTemplateAPIApi.nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeTemplateAPIApi - factory interface
 * @export
 */
export const NodeTemplateAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeTemplateAPIApiFp(configuration)
    return {
        /**
         * Returns avg spot interruption ratio for the entire period — as a single overall value and broken down per node template.
         * @summary Returns spot interruption prediction performance summary.
         * @param {NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(requestParameters: NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotInterruptionPredictionPerformanceSummary> {
            return localVarFp.nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.nodeTemplateNames, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step.
         * @summary Returns resource usage per node template.
         * @param {NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListNodeTemplatesMetrics(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodeTemplatesMetricsResponse> {
            return localVarFp.nodeTemplateAPIListNodeTemplatesMetrics(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.filterOperator, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns resource metrics and cloud costs per node template, aggregated by the specified time step, with optional filtering by cluster IDs and node labels.
         * @summary Returns resource usage per node template with label filtering.
         * @param {NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListNodeTemplatesMetricsFiltered(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodeTemplatesMetricsResponse> {
            return localVarFp.nodeTemplateAPIListNodeTemplatesMetricsFiltered(requestParameters.organizationId, requestParameters.nodeLabelsFilter, requestParameters.clusterIds, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns avg spot interruption ratio per node template per time bucket at the requested granularity.
         * @summary Returns spot interruption prediction performance metrics time-series.
         * @param {NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSpotInterruptionPredictionPerformanceMetricsResponse> {
            return localVarFp.nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.nodeTemplateNames, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary operation in NodeTemplateAPIApi.
 * @export
 * @interface NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest
 */
export interface NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly organizationId: string

    /**
     * Cluster IDs to filter the report. If empty, all clusters in the organization are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly clusterIds?: Array<string>

    /**
     * Node template names to filter the report. If empty, all node templates are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly nodeTemplateNames?: Array<string>

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly endTime?: string

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary
     */
    readonly timeZone?: string
}

/**
 * Request parameters for nodeTemplateAPIListNodeTemplatesMetrics operation in NodeTemplateAPIApi.
 * @export
 * @interface NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest
 */
export interface NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly organizationId: string

    /**
     * Cluster IDs to filter the report. If empty, all clusters in the organization are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly clusterIds?: Array<string>

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly endTime?: string

    /**
     * Granularity of data points.
     * @type {'STEP_UNSPECIFIED' | 'ONE_DAY' | 'ONE_MONTH'}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly step?: NodeTemplateAPIListNodeTemplatesMetricsStepEnum

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly pageCursor?: string

    /**
     * Logical operator for combining label requirements. Defaults to AND if unset.
     * @type {'FILTER_OPERATOR_UNSPECIFIED' | 'AND' | 'OR'}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetrics
     */
    readonly filterOperator?: NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum
}

/**
 * Request parameters for nodeTemplateAPIListNodeTemplatesMetricsFiltered operation in NodeTemplateAPIApi.
 * @export
 * @interface NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest
 */
export interface NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly organizationId: string

    /**
     * 
     * @type {NodeLabelsFilter}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly nodeLabelsFilter: NodeLabelsFilter

    /**
     * Cluster IDs to filter the report. If empty, all clusters in the organization are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly clusterIds?: Array<string>

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly endTime?: string

    /**
     * Granularity of data points.
     * @type {'STEP_UNSPECIFIED' | 'ONE_DAY' | 'ONE_MONTH'}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly step?: NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFiltered
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics operation in NodeTemplateAPIApi.
 * @export
 * @interface NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest
 */
export interface NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly organizationId: string

    /**
     * Cluster IDs to filter the report. If empty, all clusters in the organization are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly clusterIds?: Array<string>

    /**
     * Node template names to filter the report. If empty, all node templates are included.
     * @type {Array<string>}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly nodeTemplateNames?: Array<string>

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly endTime?: string

    /**
     * Granularity of data points.
     * @type {'STEP_UNSPECIFIED' | 'ONE_HOUR' | 'ONE_DAY' | 'ONE_MONTH' | 'FIVE_MINUTES'}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly step?: NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics
     */
    readonly pageCursor?: string
}

/**
 * NodeTemplateAPIApi - object-oriented interface
 * @export
 * @class NodeTemplateAPIApi
 * @extends {BaseAPI}
 */
export class NodeTemplateAPIApi extends BaseAPI {
    /**
     * Returns avg spot interruption ratio for the entire period — as a single overall value and broken down per node template.
     * @summary Returns spot interruption prediction performance summary.
     * @param {NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeTemplateAPIApi
     */
    public nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(requestParameters: NodeTemplateAPIApiNodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummaryRequest, options?: RawAxiosRequestConfig) {
        return NodeTemplateAPIApiFp(this.configuration).nodeTemplateAPIGetSpotInterruptionPredictionPerformanceSummary(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.nodeTemplateNames, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns resource metrics and cloud costs per node template, aggregated by the specified time step.
     * @summary Returns resource usage per node template.
     * @param {NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeTemplateAPIApi
     */
    public nodeTemplateAPIListNodeTemplatesMetrics(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsRequest, options?: RawAxiosRequestConfig) {
        return NodeTemplateAPIApiFp(this.configuration).nodeTemplateAPIListNodeTemplatesMetrics(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.filterOperator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns resource metrics and cloud costs per node template, aggregated by the specified time step, with optional filtering by cluster IDs and node labels.
     * @summary Returns resource usage per node template with label filtering.
     * @param {NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeTemplateAPIApi
     */
    public nodeTemplateAPIListNodeTemplatesMetricsFiltered(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListNodeTemplatesMetricsFilteredRequest, options?: RawAxiosRequestConfig) {
        return NodeTemplateAPIApiFp(this.configuration).nodeTemplateAPIListNodeTemplatesMetricsFiltered(requestParameters.organizationId, requestParameters.nodeLabelsFilter, requestParameters.clusterIds, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns avg spot interruption ratio per node template per time bucket at the requested granularity.
     * @summary Returns spot interruption prediction performance metrics time-series.
     * @param {NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeTemplateAPIApi
     */
    public nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(requestParameters: NodeTemplateAPIApiNodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsRequest, options?: RawAxiosRequestConfig) {
        return NodeTemplateAPIApiFp(this.configuration).nodeTemplateAPIListSpotInterruptionPredictionPerformanceMetrics(requestParameters.organizationId, requestParameters.clusterIds, requestParameters.nodeTemplateNames, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const NodeTemplateAPIListNodeTemplatesMetricsStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_DAY: 'ONE_DAY',
    ONE_MONTH: 'ONE_MONTH'
} as const;
export type NodeTemplateAPIListNodeTemplatesMetricsStepEnum = typeof NodeTemplateAPIListNodeTemplatesMetricsStepEnum[keyof typeof NodeTemplateAPIListNodeTemplatesMetricsStepEnum];
/**
 * @export
 */
export const NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum = {
    FILTER_OPERATOR_UNSPECIFIED: 'FILTER_OPERATOR_UNSPECIFIED',
    AND: 'AND',
    OR: 'OR'
} as const;
export type NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum = typeof NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum[keyof typeof NodeTemplateAPIListNodeTemplatesMetricsFilterOperatorEnum];
/**
 * @export
 */
export const NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_DAY: 'ONE_DAY',
    ONE_MONTH: 'ONE_MONTH'
} as const;
export type NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum = typeof NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum[keyof typeof NodeTemplateAPIListNodeTemplatesMetricsFilteredStepEnum];
/**
 * @export
 */
export const NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_HOUR: 'ONE_HOUR',
    ONE_DAY: 'ONE_DAY',
    ONE_MONTH: 'ONE_MONTH',
    FIVE_MINUTES: 'FIVE_MINUTES'
} as const;
export type NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum = typeof NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum[keyof typeof NodeTemplateAPIListSpotInterruptionPredictionPerformanceMetricsStepEnum];
